import axios from 'axios';

async function autoCreateEmployee(companyId) {
  const response = await axios.post(`/companies/${companyId}/employees/autocreate`);

  return response.data;
}

async function createCompanyEmployee(companyId, data) {
  const response = await axios.post(`/companies/${companyId}/employees`, data);

  return response.data;
}

async function createEmployee(data) {
  const response = await axios.post('/employees', { ...data });

  return response.data;
}

async function deleteEmployee(employeeId, data) {
  const response = await axios.delete(`/employees/${employeeId}`, { data });

  return response.data;
}

async function listEmployeesByCompanyId(companyId, employeeLevel = null) {
  const url = employeeLevel
    ? `/companies/${companyId}/employees?level=${employeeLevel}`
    : `/companies/${companyId}/employees`;
  const response = await axios.get(url);

  return response.data;
}

async function setPicture(employeeId, data) {
  const response = await axios.post(`/employees/${employeeId}/pictures`, data);

  return response.data;
}

async function updateEmployee(employeeId, data) {
  const response = await axios.put(`/employees/${employeeId}`, data);

  return response.data;
}

const employeeService = {
  autoCreateEmployee,
  createCompanyEmployee,
  createEmployee,
  deleteEmployee,
  listEmployeesByCompanyId,
  setPicture,
  updateEmployee,
};

export default employeeService;
